<mat-table [dataSource]="organizations" class="platform-mat-table">
  <ng-container matColumnDef="logo">
    <mat-header-cell *matHeaderCellDef>Logo</mat-header-cell>
    <mat-cell *matCellDef="let org" class="logo-cell">
      <img
        *ngIf="org.logoUrl"
        class="org-logo"
        [src]="org.logoUrl"
        [alt]="org.displayName + ' logo'"
        loading="lazy"
        decoding="async"
        (error)="handleLogoError($event)"
      />
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="displayName">
    <mat-header-cell *matHeaderCellDef>Display Name</mat-header-cell>
    <mat-cell *matCellDef="let org">{{ org.displayName }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="status">
    <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
    <mat-cell *matCellDef="let org">
      <mat-chip [color]="org.status === 'ACTIVE' ? 'primary' : 'accent'">{{ org.status }}</mat-chip>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="orgId">
    <mat-header-cell *matHeaderCellDef>Org ID</mat-header-cell>
    <mat-cell *matCellDef="let org" class="mono-cell">{{ org.orgId }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="memberCount">
    <mat-header-cell *matHeaderCellDef>Active Members (All)</mat-header-cell>
    <mat-cell *matCellDef="let org">{{ org.memberCount }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="totalSpend">
    <mat-header-cell *matHeaderCellDef>Total Spend</mat-header-cell>
    <mat-cell *matCellDef="let org">{{ formatZarFromCents(org.totalSpendZarCents) }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="monthSpend">
    <mat-header-cell *matHeaderCellDef>Month Spend</mat-header-cell>
    <mat-cell *matCellDef="let org">
      <span [matTooltip]="monthSpendTooltip(org)">
        {{ formatZarFromCents(org.currentMonthSpendZarCents) }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
    <mat-cell *matCellDef="let org" class="actions-cell">
      <button
        mat-icon-button
        color="accent"
        type="button"
        (click)="openBilling(org)"
        matTooltip="Billing details">
        <mat-icon>receipt_long</mat-icon>
      </button>
      <button
        mat-icon-button
        color="primary"
        type="button"
        (click)="editOrganization(org)"
        matTooltip="Edit organization">
        <mat-icon>edit</mat-icon>
      </button>
      <button
        mat-icon-button
        color="warn"
        type="button"
        (click)="deleteOrganization(org)"
        matTooltip="Delete organization">
        <mat-icon>delete</mat-icon>
      </button>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>

<div class="table-empty-state" *ngIf="organizations.length === 0">
  No organizations found.
</div>
